<script setup lang="ts">
import {computed, onBeforeMount} from 'vue'
import {useRoute} from 'vue-router'
import { useOrgStore } from '@/stores/org'

import {ApiKeysList, ApiKeysListCreate} from '@/pages/Organization/Settings'
import {isOwnerOrSuperUser} from '@/composables/useCan'

const orgStore = useOrgStore()
const route = useRoute()

const orgId = route.params.org_id as string
const org = computed(() => orgStore.current)
const apikeys = computed(() => orgStore.apikeys)
const apikeysLength = computed(() => apikeys.value.length)

onBeforeMount(async () => {
  await orgStore.fetchApikeys(orgId)
})
</script>

<template>
<div v-if="org">
  <div class="mb-2 flex items-center">
    <div class="basis-1/2">
      <h3 class="text-base font-bold">API Keys ({{apikeysLength}})</h3>
    </div>
    <div class="basis-1/2 flex justify-end">
      <ApiKeysListCreate v-if="isOwnerOrSuperUser(org.organization_id)" :org="org" />
    </div>
  </div>
  <ApiKeysList v-if="apikeysLength" :org="org" :apikeys="apikeys" :key="apikeysLength" />
</div>
</template>
